/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb5_SubtitleInputs */

const en_visa_eb5_subtitle = /** @type {(inputs: Visa_Eb5_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IMMIGRANT INVESTORS`)
};

const pt_visa_eb5_subtitle = /** @type {(inputs: Visa_Eb5_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`INVESTIDORES IMIGRANTES`)
};

const es_visa_eb5_subtitle = /** @type {(inputs: Visa_Eb5_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`INVERSIONISTAS INMIGRANTES`)
};

/**
* | output |
* | --- |
* | "IMMIGRANT INVESTORS" |
*
* @param {Visa_Eb5_SubtitleInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb5_subtitle = /** @type {((inputs?: Visa_Eb5_SubtitleInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb5_SubtitleInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb5_subtitle(inputs)
	if (locale === "es") return es_visa_eb5_subtitle(inputs)
	return en_visa_eb5_subtitle(inputs)
});